import { Navigate, Outlet } from 'react-router-dom';
import auth from '../config/FirebaseConfig';

const ProtectedRoutes: React.FC = () => {
  const isAuthenticated = !!auth.currentUser;
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};
export default ProtectedRoutes;
